import styled, { css } from 'styled-components';

export const MapHeader = styled.div`
  display: flex;
  border: 1px solid red;
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const Col = styled.div`
  ${({ md3 }) =>
    md3 &&
    css`
      @media (min-width: 768px) {
        -ms-flex: 1;
        flex: 1;
        max-width: 25%;
      }
    `}
  ${({ md9 }) =>
    md9 &&
    css`
      @media (min-width: 768px) {
        -ms-flex: 1;
        flex: 1;
        max-width: 75%;
      }
    `}
  ${({ md12 }) =>
    md12 &&
    css`
      @media (min-width: 768px) {
        -ms-flex: 1;
        flex: 1;
        max-width: 100%;
      }
    `}
`;

export const DataBoxContainer = styled.div`
  flex: 1;
  margin: 24px 0 0 24px;
`;

export const DataBox = styled.div`
  border: 1px solid var(--gray-secondary-light);
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: white;
  padding: 16px;
`;

export const DataText = styled.p`
  color: ${({ color }) => color && color};
  font-size: 14px;
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  margin: 0;
`;

export const MapContainer = styled.div`
  svg {
    stroke: var(--white);

    path {
      fill: var(--secondary-gray-midle);
      cursor: pointer;
      outline: none;
      fill-opacity: 0.5;

      ${({ colors }) =>
    colors &&
    colors.map(color => `
      
      &[id="${color.id}"] {
        fill: ${color.color};
      }
      
      `)}

      ${({ activeState }) =>
    activeState &&
    css`
          &[id="br-${activeState.label.toLowerCase()}"] {
            fill-opacity: 1;
          }
        `}    
      
      &:hover {
        fill: var(--secondary-gray-midle);
        fill-opacity: 0.75;
      }

      ${({ activeRegions }) =>
    activeRegions.length > 0 &&
    css`
          ${activeRegions.map(activeRegion => `        
        
          &[id="${activeRegion}"] {
            fill-opacity: 1;
          }
      `)}
        `}
    }
  }
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ObsText = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 8px;
  line-height: 10px;
  margin-bottom: 20px;
  color: var(--secondary-gray-dark);
  margin-left: 24px;
  text-align: end;
`;

export const ScaleContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ObsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;
